export default "__VITE_ASSET__CUqawDBk__"